// extracted by mini-css-extract-plugin
module.exports = {"signinForm":"SignIn_signinForm__7IGmK","links":"SignIn_links__1IZkL"};